import dayjs from "dayjs";

function DateFormat({ time, format }: any) {
  const formattedDate = dayjs(time).format(format);
  return <>{formattedDate}</>;
}

export default DateFormat;

export const formatTimeVN = (timestamp: any) => {
  // Lấy thời gian hiện tại
  const now: any = new Date();

  // Chuyển đổi chuỗi thời gian sang định dạng Date
  const date: any = new Date(timestamp);

  // Tính toán thời gian chênh lệch
  const timeDiff = Math.floor((now - date) / 1000);

  // Định dạng thời gian chênh lệch
  let formattedTime;
  if (timeDiff < 60) {
    formattedTime = "vừa xong";
  } else if (timeDiff < 3600) {
    formattedTime = `${Math.floor(timeDiff / 60)} phút trước`;
  } else if (timeDiff < 86400) {
    formattedTime = `${Math.floor(timeDiff / 3600)} tiếng trước`;
  } else if (timeDiff < 2678400) {
    formattedTime = `${Math.floor(timeDiff / 86400)} ngày trước`;
  } else if (timeDiff < 31536000) {
    formattedTime = `${Math.floor(timeDiff / 2678400)} tháng trước`;
  } else {
    formattedTime = `${Math.floor(timeDiff / 31536000)} năm trước`;
  }

  return formattedTime;
};

export const getIsoTimestamp = (dateString: any) => {
  const date = new Date(Date.parse(dateString));
  date.setHours(0, 0, 0);
  const formattedDate = date.toISOString();
  return formattedDate;
};
